import Roblox from 'Roblox';
import { EVENT_CONSTANTS, LOG_PREFIX } from '../app.config';
import { DismissOption, PromptType, ViewType } from '../constants/parameters';
import ModalState from '../store/modalState';

/**
 * A class encapsulating the events fired by this web app.
 */
export class EventServiceDefault {
  private promptType: PromptType;

  private viewType: ViewType;

  private dismissOption: DismissOption;

  constructor(promptType: PromptType, viewType: ViewType, dismissOption: DismissOption) {
    this.promptType = promptType;
    this.viewType = viewType;
    this.dismissOption = dismissOption;
  }

  sendPromptDismissedEvent(isForever: boolean): void {
    Roblox.EventStream.SendEventWithTarget(
      EVENT_CONSTANTS.eventName,
      EVENT_CONSTANTS.context.promptDismissed,
      {
        promptType: this.promptType,
        viewType: this.viewType,
        dismissOption: this.dismissOption,
        isForever
      },
      Roblox.EventStream.TargetTypes.WWW
    );
  }

  sendPopUpOpenedEvent(): void {
    if (this.viewType !== ViewType.BANNER) {
      // eslint-disable-next-line no-console
      console.warn(LOG_PREFIX, 'Pop-up opened event called with the wrong view type');
      return;
    }

    Roblox.EventStream.SendEventWithTarget(
      EVENT_CONSTANTS.eventName,
      EVENT_CONSTANTS.context.popUpOpened,
      {
        promptType: this.promptType,
        viewType: this.viewType,
        dismissOption: this.dismissOption
      },
      Roblox.EventStream.TargetTypes.WWW
    );
  }

  sendFormOpenedEvent(): void {
    Roblox.EventStream.SendEventWithTarget(
      EVENT_CONSTANTS.eventName,
      EVENT_CONSTANTS.context.formOpened,
      {
        promptType: this.promptType,
        viewType: this.viewType,
        dismissOption: this.dismissOption
      },
      Roblox.EventStream.TargetTypes.WWW
    );
  }

  sendModalStateViewedEvent(state: ModalState): void {
    Roblox.EventStream.SendEventWithTarget(
      EVENT_CONSTANTS.eventName,
      EVENT_CONSTANTS.context.modalStateViewed,
      {
        promptType: this.promptType,
        viewType: this.viewType,
        dismissOption: this.dismissOption,
        state
      },
      Roblox.EventStream.TargetTypes.WWW
    );
  }
}

/**
 * An interface encapsulating the events fired by this web app.
 *
 * This interface type offers future flexibility e.g. for mocking the default
 * event service.
 */
export type EventService = {
  [K in keyof EventServiceDefault]: EventServiceDefault[K];
};
